import hljs from 'highlight.js';
// import 'highlight.js/styles/monokai.css'; // Ou qualquer outro estilo de sua preferência
import { portugol } from '../Portugol'; // Importe a definição personalizada da sintaxe do Portugol
import '../Portugol/styles.css'; // Importe o arquivo CSS com a classe `keyword`
hljs.registerLanguage('portugol', portugol); // Registre a linguagem 'portugol' com a definição personalizada

interface PortugolCodeProps {
    code: string;
}

export const PortugolCode = ({ code }: PortugolCodeProps) => {
    const formatCode = (code: string) => {
        const formattedCode = hljs.highlight('portugol', code).value;
        return <span dangerouslySetInnerHTML={{ __html: formattedCode }} />;
    };

    return <div>{formatCode(code)}</div>;
};
